/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: 倪国晓
 * @Date: 2022-07-19 10:18:56
 * @LastEditors: 倪国晓
 * @LastEditTime: 2022-07-21 14:56:42
 */
import ColumnTypes from '@/utils/ColumnTypes';
const total_count = {
	key: 'total_count',
	label: '分配达人数',
	type: ColumnTypes.TextCell,
	fixed: 'left',
	minWidth: '100',
};
const partner_role_name = {
	key: 'partner_role_name',
	label: '跟进人',
	type: ColumnTypes.TextCell,
	minWidth: '100',
};
const add_time = {
	key: 'add_time',
	label: '操作时间',
	type: ColumnTypes.TextCell,
	minWidth: '100',
};
const operator_name = {
	key: 'operator_name',
	label: '操作人',
	type: ColumnTypes.TextCell,
	minWidth: '100',
};
const task_status = {
	key: 'task_status',
	label: '状态',
	type: ColumnTypes.taskStatusCell,
	minWidth: '100',
};
const expire_status = {
	key: 'task_status',
	label: '操作',
	type: ColumnTypes.taskOperateCell,
	minWidth: '100',
	align: 'left',
};

export const columns = [total_count, partner_role_name, add_time, operator_name, task_status, expire_status];
